import { IoIosArrowBack } from "react-icons/io";
import { useState, useEffect, useMemo } from "react";
import { db } from "../firebaseConfig";
import { doc, updateDoc, collection, getDocs } from "firebase/firestore";
import RichTextEditor from "../components/RichTextEditor";
import { withReact } from "slate-react";
import { createEditor } from "slate";
import { ThreeDots } from "react-loader-spinner";
import Swal from 'sweetalert2';

export default function EditContent({ setEditContent }) {
    const [courtFee, setCourtFee] = useState(0);
    const [headerValue, setHeaderValue] = useState(null);
    const [footerValue, setFooterValue] = useState(null);
    const [loading, setLoading] = useState(true);

    const withInlines = (editor) => {
        const { isInline } = editor;
        editor.isInline = (element) => (element.type === "link" ? true : isInline(element));
        return editor;
    };

    const editor = useMemo(() => withInlines(withReact(createEditor())), []);
    const editor2 = useMemo(() => withInlines(withReact(createEditor())), []);

    useEffect(() => {
        const fetchContent = async () => {
        try {
            const collectionRef = collection(db, "content");
            const snapshot = await getDocs(collectionRef);
            const docsArray = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

            const courtDoc = docsArray.find((d) => d.id === "courtFee");
            setCourtFee(courtDoc?.value || 0);

            const headerDoc = docsArray.find((d) => d.id === "headerText");
            setHeaderValue( headerDoc?.value && Array.isArray(headerDoc.value) ? headerDoc.value : [{ type: "paragraph", children: [{ text: headerDoc?.value || "" }] }]);

            const footerDoc = docsArray.find((d) => d.id === "footerText");
            setFooterValue( footerDoc?.value && Array.isArray(footerDoc.value) ? footerDoc.value : [{ type: "paragraph", children: [{ text: footerDoc?.value || "" }] }]);

            setLoading(false);
        } 
        
            catch (err) {
                console.error("Failed to fetch content:", err);
                Swal.fire({
                icon: "error",
                title: "Error",
                    text: "Failed to load content. Please try again later.",
                    confirmButtonColor: "#3085d6",
                });
            }
        };

        fetchContent();
    }, []);

    const handleUpdateContent = async (e) => {
        e.preventDefault();
        try {
            await updateDoc(doc(db, "content", "courtFee"), { value: Number(courtFee) });
            await updateDoc(doc(db, "content", "headerText"), { value: headerValue });
            await updateDoc(doc(db, "content", "footerText"), { value: footerValue });

            setEditContent(false);
            Swal.fire({
                icon: "success",
                title: "Content Updated!",
                text: "The content has been successfully updated.",
                confirmButtonColor: "#3085d6",
            });
        } 
        
        catch (err) {
            console.error("Failed to update content:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to update content. Please try again later.",
                confirmButtonColor: "#3085d6",
            });
        }
    };

    return (
        <div className="edit-content">
            <div className="edit-content-back-button" onClick={() => setEditContent(false)}>
                <IoIosArrowBack style={{ width: "7vw", height: "40px", color: "#EFBF84", zIndex: 1000 }} />
            </div>

            <h3 style={{ marginTop: "-30px", marginBottom: "18px" }}>Edit Content</h3>

            <form className="edit-content-form" onSubmit={handleUpdateContent}>
                <label htmlFor="courtFee">Court Fee:</label>
                <input id="courtFee" type="number" value={courtFee} min="0" required style={{ width: "13vw", margin: "0 auto" }} onChange={(e) => setCourtFee(e.target.value)}
                onFocus={(e) => e.target.select()} onWheel={(e) => e.target.blur()}/>

                <div style={{ width: "95%", margin: "15px auto 0 auto", textAlign: "left" }}>
                {!loading && headerValue && footerValue && (
                    <RichTextEditor key="header-editor" editor={editor} editor2={editor2} value={headerValue} value2={footerValue} onChange={setHeaderValue} 
                        onChange2={setFooterValue} headerText={true}/>
                )}

                {loading && <ThreeDots color="#00BFFF" height={80} width={80} style={{width: "88%"}}/>}
                </div>

                <br />
                <button type="submit" className="edit-content-button">Update Content</button>
            </form>
        </div>
    );
}